/** Shared input normalization / digit rules for finance forms. */

/** Force uppercase (bike / registration / chassis style fields). */
export function toUpperInput(raw: string): string {
  return String(raw ?? '').toUpperCase();
}

/** Digits only, capped length (mobile / Aadhaar). */
export function digitsOnly(raw: string, maxLen: number): string {
  return String(raw ?? '').replace(/\D/g, '').slice(0, maxLen);
}

export function isValidMobile10(raw: string): boolean {
  return /^\d{10}$/.test(String(raw ?? '').replace(/\D/g, ''));
}

export function isValidAadhaar12(raw: string): boolean {
  return /^\d{12}$/.test(String(raw ?? '').replace(/\D/g, ''));
}

export function mobileHint(raw: string): string {
  const d = String(raw ?? '').replace(/\D/g, '');
  if (!d) return 'Enter 10-digit mobile number';
  if (d.length < 10) return `${10 - d.length} more digit(s) needed`;
  if (d.length === 10) return 'Valid 10-digit mobile';
  return 'Mobile must be exactly 10 digits';
}

export function aadhaarHint(raw: string): string {
  const d = String(raw ?? '').replace(/\D/g, '');
  if (!d) return 'Enter 12-digit Aadhaar number';
  if (d.length < 12) return `${12 - d.length} more digit(s) needed`;
  if (d.length === 12) return 'Valid 12-digit Aadhaar';
  return 'Aadhaar must be exactly 12 digits';
}
